<template>
    <div :class="['form', 'form__submit', `form__submit--${size}`]">
        <div class="columns is-block-mobile columns--margin-1-mobile has-text-centered-mobile">
            <div class="column is-hidden-mobile custom--line"></div>
            <div class="column is-narrow">
                <component-button
                    :disabled="disabled"
                    :theme="'default'"
                    :border="true"
                    @click="notifyReset"
                    :name="'form-submit-reset'"
                >{{resetButtonText}}</component-button>
            </div>
            <div class="column is-narrow">
                <component-button
                    :disabled="disabled"
                    :animate-loading="submitButtonAnimateLoading"
                    :animate-loading-event-name="submitButtonAnimateLoadingEventName"
                    @click="submit"
                    :name="'form-submit-submit'"
                >{{submitButtonText}}</component-button>
            </div>
        </div>
        <div
            class="form__submit_error"
            v-if="error"
        >
            {{ $t('forms.submit.title') }}
        </div>
        <pop-notify
            :class="'pop__notify--reset'"
            ref="notifyreset"
            :title-text="$t('forms.submit.notify.title')"
            :content-text="$t('forms.submit.notify.content')"
            :cancel-button-text="$t('forms.submit.notify.cancel')"
            :submit-button-text="$t('forms.submit.notify.submit')"
            @emit-submit="reset"
        />
    </div>
</template>

<script>
import PopNotify from '@/components/default/shared/PopNotify'
import { scrollToTop } from '@/functions'
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  components: {
    ComponentButton,
    PopNotify },
  name: 'form-submit',
  data () {
    return {
      error: false
    }
  },
  props: {
    resetButtonText: {
      type: String,
      default: function () {
        return this.$t('forms.submit.buttons.resetChanges')
      }
    },
    submitButtonText: {
      type: String,
      default: function () {
        return this.$t('forms.submit.buttons.saveChanges')
      }
    },
    submitButtonAnimateLoading: {
      type: Boolean,
      default: true
    },
    submitButtonAnimateLoadingEventName: {
      type: String,
      default: 'sending'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'default'
    }
  },
  methods: {
    notifyReset: function () {
      this.$refs.notifyreset.openNotify()
    },
    reset: function () {
      this.$emit('reset')
      scrollToTop()
    },
    submit: function () {
      this.$emit('submit')
    },
    showError: function () {
      this.error = true
    },
    hideError: function () {
      this.error = false
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formsubmit";
</style>
